// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: var(--color-background-alt);
}

h1 {
  font-size: 30px;
  line-height: 116%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  font-family: BricolageGrotesque;
  text-align: center;
  margin-bottom: 20px;
}

h2,
h3,
h4,
h5 {
  font-size: 20px;
  line-height: 116%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  margin-top: 20px;
  margin-bottom: 10px;
}
@media (max-width: 992px) {
  h2,
  h3,
  h4,
  h5 {
    font-size: 16px;
  }
}

h4 {
  font-size: 18px;
}
@media (max-width: 992px) {
  h4 {
    font-size: 15px;
  }
}

p {
  font-size: 16px;
  line-height: 120%;
  vertical-align: middle;
}
@media (max-width: 992px) {
  p {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/impressum/impressum.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,yCAAA;AADD;;AAIA;EACE,eAAA;EACD,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACC,mBAAA;AADF;;AAIA;;;;EAIC,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AADD;ACnBE;EDUF;;;;IAaE,eAAA;EAGA;AACF;;AAAA;EACC,eAAA;AAGD;AC/BE;ED2BF;IAGE,eAAA;EAKA;AACF;;AAFA;EACC,eAAA;EACA,iBAAA;EACA,sBAAA;AAKD;AC1CE;EDkCF;IAME,eAAA;EAMA;AACF","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n\t--background: var(--color-background-alt);\n}\n\nh1 {\n  font-size: 30px;\n\tline-height: 116%;\n\tletter-spacing: 0.02em;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tfont-family: BricolageGrotesque;\n\ttext-align: center;\n  margin-bottom: 20px;\n}\n\nh2,\nh3,\nh4,\nh5 {\n\tfont-size: 20px;\n\tline-height: 116%;\n\tletter-spacing: 0.02em;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tmargin-top: 20px;\n\tmargin-bottom: 10px;\n\n\t@include mobile {\n\t\tfont-size: 16px;\n\t}\n}\n\nh4 {\n\tfont-size: 18px;\n\t@include mobile {\n\t\tfont-size: 15px;\n\t}\n}\n\np {\n\tfont-size: 16px;\n\tline-height: 120%;\n\tvertical-align: middle;\n\n\t@include mobile {\n\t\tfont-size: 14px;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
